import { Box } from "@mzc-pdc/ui";

const CircledIcon = ({ size, color, padding = 0, children, sx }) => {
    return (
        <Box
            sx={{
                display: `inline-flex`,
                alignItems: `center`,
                justifyContent: `center`,
                width: size,
                height: size,
                padding: padding,
                borderRadius: 20,
                backgroundColor: color,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

const CircledButtonIcon = ({ size, color, children, onClick = () => {} }) => {
    return (
        <button>
            <Box
                sx={{
                    display: `inline-flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    width: size,
                    height: size,
                    borderRadius: 20,
                    backgroundColor: color,
                }}
                onClick={onClick}
            >
                {children}
            </Box>
        </button>
    );
};
export { CircledIcon, CircledButtonIcon };
